import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import moment from 'moment';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { catchError, map, shareReplay, switchMap, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { VersionFileDto } from './new-version.types';
import { VERSION_CHECK_POLLING_INTERVAL } from './new-version.constants';

@Injectable()
export class NewVersionService {
  private versionCheckTimer: Observable<boolean>;
  private oldVersion: string = environment.appVersion;
  private unsubscribeSubject = new Subject<void>();

  constructor(private httpClient: HttpClient, @Inject(VERSION_CHECK_POLLING_INTERVAL) private polingInterval: string) {}

  observe$(): Observable<boolean> {
    const interval = moment.duration(this.polingInterval).as('millisecond');
    this.versionCheckTimer =
      this.versionCheckTimer ||
      timer(0, interval).pipe(
        switchMap(() => this.checkVersion(this.oldVersion).pipe(catchError(() => EMPTY))),
        takeUntil(this.unsubscribeSubject),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );
    return this.versionCheckTimer;
  }

  unobserve(): void {
    this.versionCheckTimer = null;
    this.unsubscribeSubject.next();
  }

  private checkVersion(oldVersion: string): Observable<boolean> {
    return this.httpClient
      .get<VersionFileDto>(`/version.json?t=${new Date().getTime()}`)
      .pipe(map(({ version }) => oldVersion !== version));
  }
}
